<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <div class="col-12 col-md-4 easyBookingIcon-row">
          <EasyBookingIcon
            :primaryColor="user.config.parameters.parameters.colorprimary"
            :backgroundColor="user.config.parameters.parameters.colorbackground"
          />
        </div>
        <div class="col-12 col-md-8">
          <div class="pa-xs-4 pa-md-8 mt-md-10">
            <h1 class="text-center">{{ $t('pageIntro.mainHeader') }}</h1>
            <p class="text-center mt-0 mt-md-5">{{ $t('pageIntro.subHeader') }}</p>
            <LookupInformation />
            <StateButton :disabled="disableBtn" :label="this.text.buttonNext" @btn-click="submitClick" />
            <Loader v-if="this.user.loading" />
          </div>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//Components
import LookupInformation from '@/components/LookupInformation.vue';
import Loader from '@/components/Loader.vue';
import StateButton from '@/components/StateButton.vue';
import EasyBookingIcon from '@/assets/images/easyBookingIcon/easyBookingIcon.vue';

//Functionality
import localizationTexts from '@/localization/texts.json';
import helpers from '@/settings/helpers';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: userGetters } = createNamespacedHelpers('user');

export default {
  name: 'Home',
  components: {
    LookupInformation,
    Loader,
    StateButton,
    EasyBookingIcon
  },
  data() {
    return {
      text: {
        buttonNext: ''
      },
      disableBtn: true,
      localPlate: '',
      localKilometers: '',
      localMake: '',
      localModel: ''
    };
  },
  methods: {
    showappointmentiffalse(appointment) {
      return appointment ? appointment.done : true;
    },
    submitClick() {
      this.$store.dispatch('user/initValidation', false);
      helpers.sendGTM({ event: 'easybooking-click', eventCategory: 'home', eventAction: 'next' }, this.user.config.host);
      this.$router.push({ name: 'Service' });
    },
    checkBtn() {
      // abort if error
      if (this.user.registrationplateError) {
        this.disableBtn = true;

        // manual model pick
      } else if (this.user.registrationplateerrormessagekey === 'cdkMmvIdentification') {
        if (
          this.localMake &&
          this.localMake.length > 0 &&
          this.localModel &&
          this.localModel.length > 0 &&
          this.localPlate &&
          this.localKilometers &&
          this.localPlate.length > 0 &&
          this.localKilometers > 0
        ) {
          this.disableBtn = false;
        } else {
          this.disableBtn = true;
        }

        // normal plate lookup
      } else {
        if (this.localPlate && this.localKilometers && this.localPlate.length > 0 && this.localKilometers > 0) {
          this.disableBtn = false;
        } else {
          this.disableBtn = true;
        }
      }
    }
  },
  computed: {
    ...userGetters(['user']),
    plate() {
      return this.user.car.registrationplate;
    },
    km() {
      return this.user.kilometers;
    },
    make() {
      return this.user.car.maketext;
    },
    model() {
      return this.user.car.varianttext;
    },
    checkError() {
      return this.user.registrationplateError;
    }
  },
  watch: {
    plate(newValue) {
      this.localPlate = newValue;
      this.checkBtn();
    },
    km(newValue) {
      this.localKilometers = newValue;
      this.checkBtn();
    },
    make(newValue) {
      this.localMake = newValue;
      this.checkBtn();
    },
    model(newValue) {
      this.localModel = newValue;
      this.checkBtn();
    },
    checkError() {
      this.checkBtn();
    }
  },
  mounted() {
    this.text.buttonNext = localizationTexts[this.user.config.language].button.next;

    // fill out form with data in case user navigates back
    if (this.user.car.registrationplate) {
      this.localPlate = this.user.car.registrationplate;
    }
    if (this.user.kilometers) {
      this.localKilometers = this.user.kilometers;
    }
    if (this.user.car.maketext) {
      this.localMake = this.user.car.maketext;
    }
    if (this.user.car.varianttext) {
      this.localModel = this.user.car.varianttext;
    }
    this.checkBtn();
  }
};
</script>

<style scoped lang="scss">
.easyBookingIcon-row {
  margin-bottom: 15px;
}
</style>

<i18n src="../localization/texts.json"></i18n>
